import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/$customerId/builder")({
  beforeLoad: ({ params, search }) => { throw redirect({ to: "/app/$customerId/journey", params, search, replace: true }); },
});
